/** CMS-editable footnote shown under the Golf Rounds pricing on the Review
 * & Pay checkout page — e.g. to note that caddie tips aren't included in
 * the golf fees. This component is only used by the admin's live
 * PreviewPane (via BlockRenderer); the real checkout page renders the same
 * `text` field itself, inline within the Golf Rounds card, since this
 * footnote isn't a standalone page section like the rest of the block CMS
 * — see the "checkout" CMS block usage in PackageCheckoutView.jsx. */
export default function CheckoutFootnotes({ fields }) {
  const text = fields?.text?.trim();
  if (!text) return null;
  return (
    <div className="bg-gray-50 p-6">
      <p className="text-xs text-gray-500 italic max-w-2xl whitespace-pre-line">{text}</p>
    </div>
  );
}
